"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
exports.styles = {
    global: {
        "html,body,#root": {
            bgColor: "lifted.gray.50",
            color: "black",
            height: "100%",
        },
    },
};
